import { useMutation } from '@tanstack/react-query';
import { publicOptIn } from '../../../services/broadcastService';

interface IOptInError {
  cause?: number;
  message?: string;
  data?: { errorMessage?: string };
}

export const usePublicOptIn = () => {
  const { mutate, isLoading, isSuccess, isError, error } = useMutation<void, IOptInError, string>(
    (token: string) => publicOptIn(token)
  );

  return {
    optIn: mutate,
    isLoading,
    isSuccess,
    isError,
    error,
  };
};
